import CourseHeader from "../components/CourseHeader";
import Solutions from "../section/solutionspage/Solutions";

export default function SolutionPage() {
  return (
    <div>
      <CourseHeader />
      <div className="min-h-screen bg-[#F8FAFC] pt-24">
        <Solutions />
      </div>
    </div>
  )
}